function assertLightSensorListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("LightSensor.addListener: listener must be a function");
  }
}
function assertUpdateInterval(intervalMs) {
  if (typeof intervalMs !== "number" || !Number.isFinite(intervalMs) || intervalMs < 0) {
    throw new Error("LightSensor.setUpdateInterval: interval must be a finite number at least 0");
  }
}
export {
  assertLightSensorListener,
  assertUpdateInterval
};
//# sourceMappingURL=validate.js.map
